import { useState } from 'react';
import { login, setAuthenticated } from '../utils/auth';

export default function Login({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError('Please enter both your username and password.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await login(username.trim(), password);
      setAuthenticated(username.trim());
      onSuccess();                                                                                               
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (                     
    <div className="login-page">
      <div className="login-panel login-panel--brand">
        <div className="login-brand-content">
          <img src="/definitelogo.png" alt="Definite Assurance" className="login-logo" />
          <h1>Definite Assurance</h1>
          <p className="login-tagline">API Documentation Portal</p>
          <ul className="login-highlights">
            <li>Client &amp; intermediary onboarding</li>
            <li>Quoting, proposals &amp; policy lifecycle</li>
            <li>Payments, extensions &amp; certificates</li>
          </ul>
        </div>
        <div className="login-brand-glow" aria-hidden="true" />
      </div>

      <div className="login-panel login-panel--form">
        <form className="login-card" onSubmit={handleSubmit} noValidate>
          <h2>Sign in</h2>
          <p className="login-subtitle">
            Enter the credentials issued to you separately to access the API documentation.
          </p>

          <label className="field-label" htmlFor="username">
            Username
          </label>
          <div className="field-control">
            <input
              id="username"
              type="text"
              autoComplete="username"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={submitting}
            />
          </div>

          <label className="field-label" htmlFor="password">
            Password
          </label>
          <div className="field-control">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={submitting}
            />
            <button
              type="button"
              className="field-toggle"
              onClick={() => setShowPassword((s) => !s)}
              tabIndex={-1}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-submit" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>

          <p className="login-footnote">
            Don&rsquo;t have credentials? Contact your Definite Assurance administrator &mdash;
            login details are shared through a separate secure document.
          </p>
        </form>
      </div>
    </div>
  );
}
